
<h1 class="text-2xl font-bold mt-5">{{ '#COUPONS.DAILY_BALANCE.TITLE' | translate }}</h1>

@if (!(loading$ | async)) {
  <div class="flex flex-row justify-between row-no-wrap balance-header mt-5 mb-4">
    <div class="flex flex-col balance-card redeem mr-3">
      <p class="card-header">{{ '#COUPONS.DAILY_BALANCE.OVERVIEW.TITLE_REDEEM' | translate }}</p>
      <div class="card-amount">{{ (dailyBalance$ | async)?.totalDebit || 0 | number:'1.2-2' }} EUR</div>
    </div>
    <div class="flex flex-col balance-card charge ml-3">
      <p class="card-header">{{ '#COUPONS.DAILY_BALANCE.OVERVIEW.TITLE_CHARGE' | translate }}</p>
      <div class="card-amount">{{ (dailyBalance$ | async)?.totalCharged || 0 | number:'1.2-2' }} EUR</div>
    </div>
  </div>
  @if (dailyBalance$ | async; as dailyBalance) {
    <div class="flex flex-col transaction-list">
      <p class="text-overline color-tertiary">{{ '#COUPONS.DAILY_BALANCE.LIST.HEADER' | translate }}</p>
      @for (transaction of dailyBalance.transactions; track transaction) {
        <div class="flex flex-row justify-between row-no-wrap transaction-list-item">
          <div class="info">
            <p class="text-body light weight-bold">{{ transaction.time | date:'dd.MM.yyyy'}}</p>
            <p class="text-body size-l">{{ (transaction.action | uppercase) !== 'CHARGE' ? ('#COUPONS.DAILY_BALANCE.LIST.LABEL_REDEEM' | translate ) : ('#COUPONS.DAILY_BALANCE.LIST.LABEL_CHARGE' | translate) }}</p>
          </div>
          <div
            class="text-body size-l"
          [ngClass]="[(transaction.action === 'charge') ? 'charged' : 'redeemed']">{{transaction.amount | number:'1.2-2'}} EUR</div>
        </div>
      }
    </div>
    <div class="sum">
      <div class="flex flex-row justify-between amount weight-bold mt-4">
        <div class="amount weight-bold">{{ '#COUPONS.DAILY_BALANCE.LIST.TOTAL_LABEL' | translate }}</div>
        {{ dailyBalance.total | number:'1.2-2' }} EUR
      </div>
    </div>
  }
} @else {
  <div class="flex flex-row justify-center loading-container">
    <soft-loading-spinner></soft-loading-spinner>
  </div>
}

